import React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { AnimatePresence, motion } from "framer-motion";

import CrossIcon from "assets/landing/icons/burger-icons/CrossIcon";
import { Link, useLocation } from "react-router-dom";
import {
  NAVIGATION_DASHBOARD,
  NAVIGATION_LANDING,
} from "../LandingHeader/components/Navigation";
import { Button } from "ui-kit/Button";
import { NavItem } from "../LandingHeader/components/NavItem";
import AnimatedButton from "../PresentationSection/AnimatedButton";
import AGNTHubIcon from "assets/svgComponents/PresaleBlock/AGNTHubIcon.svg";
import { useTranslation } from "react-i18next";

type BurgerMenuProps = {
  isOpen: boolean;
  handleClose: () => void;
};

const BurgerMenu: React.FC<BurgerMenuProps> = ({ isOpen, handleClose }) => {
  const location = useLocation();
  const pathname = location.pathname;
  const { t } = useTranslation();

  const isLanding = pathname === "/";

  return (
    <Dialog.Root open={isOpen} onOpenChange={handleClose}>
      <AnimatePresence>
        {isOpen && (
          <Dialog.Portal forceMount>
            <Dialog.DialogOverlay className="fixed inset-0" />
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.15, ease: "easeOut" }}
              className="fixed top-0 right-0 z-[1200] m-[8px]"
            >
              <Dialog.Content className="flex ">
                <Dialog.Title className="sr-only">{t("Menu")}</Dialog.Title>

                <motion.div className="flex overflow-x-hidden flex-col items-end bg-[#1a1a1a] font-luxora-regular w-[290px] shadow-custom burger-border p-[16px] mb-[16px]">
                  <button
                    onClick={handleClose}
                    className="size-[29px] max-lg:size-[29px] flex items-center justify-center rounded-lg bg-[#333333] shadow-custom"
                  >
                    <CrossIcon
                      className={"size-[20px] max-lg:size-[21px]"}
                    />
                  </button>
                  <div className="overflow-y-auto w-full max-h-[80vh] py-2">
                    {isLanding ? (
                      <>
                        {NAVIGATION_LANDING(t).map((link: any) => {
                          return (
                            <NavItem
                              label={link.label}
                              icon={link.icon}
                              link={link.link}
                              key={link.label}
                              isMobile
                              closeMenu={handleClose}
                              isLink={link.link.startsWith("http")}
                              isDark={!isLanding}
                            />
                          );
                        })}
                        <div className="relative">
                          <Link to={"/dashboard"}>
                            <Button
                              onClick={handleClose}
                              className="inline-flex w-full items-center max-lg:justify-start gap-[12px] pl-[8px] pr-[20px] max-lg:gap-[5px] max-lg:!p-[8px] !py-[9px] h-auto !rounded-[16px]
                                    border-none shadow-[0px_6px_7.5px_0px_#0000000f] max-lg:!rounded-2xl max-lg:before:!rounded-2xl
                                    bg-[linear-gradient(90deg,rgba(255,166,134,1)_0%,rgba(255,173,174,1)_40%,rgba(207,178,255,1)_100%),linear-gradient(0deg,rgba(233,235,243,1)_0%,rgba(233,235,243,1)_100%)]
                                    before:content-[''] before:absolute before:inset-0 before:p-px before:rounded-[16px] before:[background:linear-gradient(107deg,rgba(255,255,255,1)_0%,rgba(255,255,255,0)_100%)]
                                    before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] before:[-webkit-mask-composite:xor]
                                    before:[mask-composite:exclude] before:z-[1] before:pointer-events-none hover:opacity-90 transition-opacity"
                            >
                              <div className="flex bg-white rounded-[8px] max-lg:rounded-[8px] items-center justify-center w-[32px] h-[32px] max-lg:w-[32px] max-lg:h-[32px]">
                                <img src={AGNTHubIcon} alt="" />
                              </div>
                              <span className="font-luxora-medium  font-normal text-white text-[14px] max-lg:text-14m tracking-[0] leading-[110%] whitespace-nowrap">
                                {t("navigation.getAttsToken")}
                              </span>
                            </Button>
                          </Link>
                        </div>
                      </>
                    ) : (
                      <>
                        {NAVIGATION_DASHBOARD(t).map((link: any) => {
                          return (
                            <NavItem
                              isLink={true}
                              label={link.label}
                              icon={link.icon}
                              link={link.link}
                              key={link.label}
                              isMobile
                              closeMenu={handleClose}
                              isDark
                            />
                          );
                        })}

                        <AnimatedButton isHeader />
                      </>
                    )}
                  </div>
                </motion.div>
              </Dialog.Content>
            </motion.div>
          </Dialog.Portal>
        )}
      </AnimatePresence>
    </Dialog.Root>
  );
};

export default BurgerMenu;
